// src/pages/DashboardRedirect.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";

const DashboardRedirect = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, loadingUser } = useAuth();

  useEffect(() => {
    if (loadingUser) return;

    if (!user) {
      // console.log("for test - now navigating to Login...", {from: "DashboardRedirect.js", token: localStorage.getItem("token"), role: localStorage.getItem("role"), appId: localStorage.getItem("active_app_id"), pathname: window.location.pathname});
      navigate("/login", { replace: true });
      return;
    }

    navigate("/my-summary", { replace: true });
  }, [user, loadingUser, navigate]);

  return (
    <div style={{ padding: "1rem", fontWeight: "bold" }}>
      {t("dashboard_redirect.redirecting")}
    </div>
  );
};

export default DashboardRedirect;